import { appendReferToAttachmentsOption } from './insurers'

export const CONDITION_SPECIFIC_FORM_CODES = Object.freeze({
    cancer: 'IECancer',
    cardiovascular: 'IECR',
    mentalHealth: 'IEMentalHealth',
    stroke: 'IEStroke',
    multipleSclerosis: 'IEMS',
    heartDisease: 'IEHeart',
    heartDisorder: 'IEHeartDisorder',
    hepatitis: 'IEHepatitis',
    kidney: 'IEKidney',
    respiratory: 'IERespiratory',
    diabetes: 'IEDiabetes',
    tgcm: 'IETGCM',
    neurological: 'IENC',
    liver: 'IELBC',
    prostate: 'IEProstate',
    gastro: 'IEGD',
    alcohol: 'IEAASM',
    musculoskeletal: 'IEMusculoskeletal',
    eatingDisorder: 'IEEatingDisorder'
})

export const FORM_CODES = Object.freeze({
    pmar: 'FrmPMAR',
    mir: 'MIR',
    ...CONDITION_SPECIFIC_FORM_CODES
})


// Hepatitis form constants
export const hepatitisTypeOptions = ['Hepatitis A', 'Hepatitis B', 'Hepatitis C', 'HIV']
export const hepatitisTypeValidOptions = appendReferToAttachmentsOption(hepatitisTypeOptions)